// frontend/src/components/BookingManagement.js

import { useState, useCallback } from 'react';
import { isAdmin } from '../utils/roleUtils';
import { useTheme } from '../contexts/ThemeContext';
import { usePreferences } from '../contexts/PreferenceContext';
import BookingView from './booking-management/BookingView';
import BookingCreateForm from './booking-management/BookingCreateForm';

const BookingManagement = ({ userRole, currentEntity }) => {
  const { background, cn } = useTheme();
  const { entitySettings } = usePreferences();
  const isAdminUser = isAdmin(userRole);
  const [bookingRefreshKey, setBookingRefreshKey] = useState(0);
  const bookingWindowDays = entitySettings?.booking_window_days || currentEntity?.booking_window_days || 14;
  const entityId = currentEntity?.entityId;
  const currentUserId = localStorage.getItem('userId');

  const handleBookingCreated = useCallback(() => {
    setBookingRefreshKey((prev) => prev + 1);
  }, []);

  const renderAdminCreateForm = useCallback(
    (options = {}) => (
      <BookingCreateForm
        key={`admin-booking-form-${entityId}`}
        userRole={userRole}
        currentEntity={currentEntity}
        isAdminBooking
        embedded={options.embedded !== undefined ? options.embedded : true}
        onBookingCreated={() => {
          handleBookingCreated();
          if (typeof options.onSuccess === 'function') {
            options.onSuccess();
          }
        }}
      />
    ),
    [currentEntity, entityId, handleBookingCreated, userRole]
  );

  return (
    <div className={cn("max-w-6xl mx-auto p-4", background.primary)}>
      <BookingView
        userRole={userRole}
        entityId={entityId}
        userId={currentUserId}
        currentEntity={currentEntity}
        bookingWindowDays={bookingWindowDays}
        refreshKey={bookingRefreshKey}
        renderCreateForm={isAdminUser ? renderAdminCreateForm : null}
      />

      {!isAdminUser && (
        /* An unsent booking draft contains entity-owned routes, waypoints, schedules,
         * and verification state. Replace the whole form at the entity boundary so
         * none of that tenant-scoped state can be combined with the next entity. */
        <BookingCreateForm
          key={`rider-booking-form-${entityId}`}
          userRole={userRole}
          currentEntity={currentEntity}
          onBookingCreated={handleBookingCreated}
        />
      )}
    </div>
  );
};

export default BookingManagement;
